"use client"

import TrackOrderForm from "@/components/TrackOrderForm/trackOrderForm"
import TrackOrderSignIn from "@/components/TrackOrderSignIn"
import {
  useUserContext 
} from "@/context/user"
import {
  useRouter 
} from "next/navigation"
import classes from "./trackOrderPage.module.css"

const TrackOrderPage = () => {
  const router = useRouter()

  const [{
    isSignedIn 
  }] = useUserContext()

  const containerClass = isSignedIn
    ? classes.singleFormContainer
    : classes.container

  const afterSubmit = () => {
    router.push("/order-history")
  }

  const maybeSignForm = isSignedIn ? null : (
    <div className={classes.signInForm}>
      <h2 className={classes.formTitle}>Login to Track</h2>
      <TrackOrderSignIn
        afterSubmit={afterSubmit}
        showTitle={false}
        showFooter={false}
        classes={{
          signInButton: classes.signInButton 
        }}
      />
    </div>
  )

  return (
    <div className={classes.root}>
      <h2 className={classes.title}>Track Your Order</h2>
      <div className={containerClass}>
        <div className={classes.trackingForm}>
          <h2 className={classes.formTitle}>Tracking by Email</h2>
          <TrackOrderForm
            classes={{
              trackOrderButton: classes.trackOrderButton 
            }}
          />
        </div>
        {maybeSignForm}
      </div>
    </div>
  )
}

export default TrackOrderPage
